module.exports = __webpack_public_path__ + "img/glass.1d8af1bd.svg";